import React from "react";
import Swal from "sweetalert2";
import { useHistory } from 'react-router-dom';
import { useForm, Controller } from "react-hook-form";

// Material-UI
import { Button, Container, Grid, makeStyles } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
// Components
import NavbarUser from "../components/NavbarUser";
import Background from "../components/BackgroundPattern";
import TitlePage from "../components/TitlePageUser";
import TextPilih from "../components/TextPilih";
import Footer from "../components/Footer";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh"
  },
  bgWhite: {
    backgroundColor: "white"
  }
}));

const PilihNilai = ({classes}) => {
  const { handleSubmit, control } = useForm();
  const history = useHistory();
  const onSubmit = (data) => {
    if (data.pilihNilai === "Kognitif") {
      return history.push('/user/nilai/kognitif')
    } else if (data.pilihNilai === "Afektif") {
      return history.push('/user/nilai/afektif')
    } else {
      return Swal.fire({
        icon: "error",
        title: "Daftar Nilai Tidak Tersedia",
        text: "Silahkan Pilih Daftar Nilai yang lain!",
      });
    }
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs={6} sm={6} md={5}>
            <FormControl className={classes.bgWhite} variant="outlined" margin="normal" required fullWidth>
              <InputLabel id="pilihNilaiLabel">{"Pilih Daftar Nilai"}</InputLabel>
              <Controller
                as={
                  <Select
                    labelId="pilihNilaiLabel"
                    id="pilihNilai"
                    label="Pilih Nilai"
                  >
                    <MenuItem value="">
                      <em>{"Pilih Daftar Nilai"}</em>
                    </MenuItem>
                    <MenuItem value="Kognitif">{"Kognitif"}</MenuItem>
                    <MenuItem value="Afektif">{"Afektif"}</MenuItem>
                  </Select>
                }
                name="pilihNilai"
                control={control}
                defaultValue=""
                required
              />
            </FormControl>
          </Grid>
          <Grid item xs={5} sm={4} md={3}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              fullWidth
            >
              {"Pilih"}
            </Button>
          </Grid>
          <Grid item xs={1} sm={2} md={4}></Grid>
        </Grid>
      </form>
    </Container>
  );
};

const UserNilai = () => {
  const classes = useStyles();

  return (
    <section id="user-nilai" className={classes.container}>
      <Background/>
      <NavbarUser />
      <Container style={{flex: "1"}}>
        <TitlePage text="Daftar Nilai" />
        <TextPilih text="Pilih Daftar Nilai yang akan ditampilkan"/>
        <PilihNilai classes={classes}/>
      </Container>
      <Footer />
    </section>
  );
};

export default UserNilai;
